"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var VFDebugHelper = (function () {
    function VFDebugHelper(scene) {
        this.scene = scene;
    }
    VFDebugHelper.prototype.toggleDebugView = function () {
        var debugLayer = this.scene.debugLayer;
        if (debugLayer.isVisible()) {
            this.axesViewer.dispose();
            this.scene.freeze();
            debugLayer.hide();
        }
        else {
            this.axesViewer = new babylonjs_1.AxesViewer(this.scene, 1);
            this.scene.unfreeze();
            debugLayer.show({ overlay: true });
        }
    };
    return VFDebugHelper;
}());
exports.default = VFDebugHelper;
